import { render, staticRenderFns } from "./businessList1.vue?vue&type=template&id=27dacdf3&scoped=true"
import script from "./businessList1.vue?vue&type=script&lang=js"
export * from "./businessList1.vue?vue&type=script&lang=js"
import style0 from "./businessList1.vue?vue&type=style&index=0&id=27dacdf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dacdf3",
  null
  
)

export default component.exports